import { composeValidators, createRequiredValidator, noopValidator, normalizeValidator, } from './validator';
const getSchemaValidator = (validation) => {
    if (validation == null) {
        return composeValidators([]);
    }
    const { required, validator } = validation;
    const validators = [];
    if (required) {
        validators.push(createRequiredValidator());
    }
    validators.push(normalizeValidator(validator));
    return composeValidators(validators);
};
export const getInternalValidator = (validation, componentSchema) => {
    const validator = getSchemaValidator(validation);
    if (componentSchema == null) {
        return validator;
    }
    const componentRequiredValidator = componentSchema.required
        ? createRequiredValidator()
        : noopValidator;
    return composeValidators([componentRequiredValidator, validator, componentSchema.validator]);
};
